import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import CustomerInternetSpeed from '../../Partials/CustomerInternetSpeed/CustomerInternetSpeed';
import { reportDWH, setSelectedSpeed } from '../../AddonsBlockSlice';
import { createSaleAsync, setErrorPageAsync } from '../../AddonsBlockAsyncThunk';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const InternetSpeedPage = (props) => {
    const [internetSpeedError, setInternetSpeedError] = useState('');
    const [selectedSpeed, setSelectedSpeed] = useState(null);
    const [serviceData, setServiceData] = useState({
        isConfirmTerms: { value: false, error: '' },
        email: { value: props.primaryEmail, error: '' }
    });

    useEffect(() => {
        props.reportDWH({ actionType: 'Speed List Page', status: 'Ongoing', messageText: 'Speed List Page Page Displayed' });
        gtag4({ event: `Addon_${props.flowType}_Step1_SelectProductPage`, step: '1', action: 'SelectProductPage', funnel_name: `Addon_${props.flowType}` });
    }, []);

    return (
        <div className='internet-speed-page'>

            <CustomerInternetSpeed downloadSpeed={props.customerSpeed.downloadSpeed} uploadSpeed={props.customerSpeed.uploadSpeed} />

            <div className='internet-speed-title'> בחרו את המהירות </div>

            <div className='speed-list'>

                {
                    props.upgradeSpeedList &&
                    props.upgradeSpeedList.map((item, index) => {
                        return (
                            <div className='speed-item' key={index}>
                                <input type='radio' id={`radio-subscriber-${index}`} name='speed' onChange={() => handleOnSpeedClick(item)} />
                                <label htmlFor={`radio-subscriber-${index}`}>
                                    <div className='details'>
                                        <div className='radio-icon'></div>
                                        <div className='details-wrapper'>
                                            <div className='speed-name'> מהירות הורדה עד {item.downloadSpeed}MB </div>
                                            <div className='speed-description'> מהירות העלאה עד {item.uploadSpeed}MB </div>
                                        </div>
                                        <div className='price-wrapper'>
                                            {
                                                displayPrice(item.price) == 0 ? (
                                                    <span className='no-price'> ללא עלות </span>
                                                ) : (
                                                    <>
                                                        <div className='price'> {displayPrice(item.price)}<div className='nis'>₪</div> </div>
                                                        <div className='price-text'> לחודש </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                </label>
                            </div>
                        );
                    })
                }

                {/* <div className='speed-item' key={0}>
                    <input type='radio' id={`radio-subscriber-${0}`} name='speed' onChange={() => handleOnSpeedClick(null)} />
                    <label htmlFor={`radio-subscriber-${0}`}>
                        <div className='details'>
                            <div className='radio-icon'></div>
                            <div className='details-wrapper'>
                                <div className='speed-name'> מהירות הורדה עד 5,000MB </div>
                                <div className='speed-description'> מהירות הורדה עד 5,000MB </div>
                            </div>
                            <div className='price-wrapper'>
                                <div className='price'> <div className='nis'>₪</div>{168} </div>
                                <div className='price-text'> לחודש </div>
                            </div>
                        </div>
                        <div className='price-details'>
                            <div className='price-row-wrapper'>
                                <div className='row-text'> חיוב לחודש הראשון </div>
                                <div className='row-price'>
                                    <div className='price'> <div className='nis'>₪</div>{99} </div>
                                </div>
                            </div>
                            <div className='price-row-wrapper'>
                                <div className='row-text'> חיוב חודשי החל מהחודש השני </div>
                                <div className='row-price'>
                                    <div className='price'> <div className='nis'>₪</div>{129} </div>
                                    <div className='price-text'> לחודש </div>
                                </div>
                            </div>
                        </div>
                    </label>
                </div>

                <div className='speed-item' key={2}>
                    <input type='radio' id={`radio-subscriber-${2}`} name='speed' onChange={() => handleOnSpeedClick(null)} />
                    <label htmlFor={`radio-subscriber-${2}`}>
                        <div className='details'>
                            <div className='radio-icon'></div>
                            <div className='details-wrapper'>
                                <div className='speed-name'> מהירות הורדה עד 5,000MB </div>
                                <div className='speed-description'> מהירות הורדה עד 5,000MB </div>
                            </div>
                            <div className='price-wrapper'>
                                <div className='price'> <div className='nis'>₪</div>{168} </div>
                                <div className='price-text'> לחודש </div>
                            </div>
                        </div>
                    </label>
                </div> */}

                {internetSpeedError && <div className='error-not-selected'>{internetSpeedError}</div>}

            </div>

            {
                props.isDisplayMoreSpeedLink &&
                <div className='link-wrapper'>
                    <a href='#' onClick={(e) => handleMoreSpeedClick(e)}>אני רוצה לשמוע על עוד מהירויות</a>
                </div>
            }

            {
                props.internetSpeedRemarkList && props.internetSpeedRemarkList.length > 0 &&
                <div className='remarks-wrapper'>
                    {
                        props.internetSpeedRemarkList.map((item, index) => {
                            return (
                                <div className='remark'>
                                    <span> {item} </span>
                                </div>
                            );
                        })
                    }
                </div>
            }

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='אישור והזמנה'
                    onclick={handleOnContinue}
                    formid='service-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}
                />
            </div>

        </div>
    );


    function displayPrice(price) {
        if (typeof price === 'number') {
            return parseFloat(price.toFixed(2));
        }
        else {
            const res = parseFloat(parseFloat(price).toFixed(2));
            return res == NaN ? 0 : res;
        }
    };


    function handleOnSpeedClick(item) {
        setSelectedSpeed(item);
        setInternetSpeedError('');
    }


    function handleMoreSpeedClick(e) {
        e.preventDefault();
        props.reportDWH({ actionType: 'Speed List Page', status: 'Ongoing', messageText: 'Link to additional speeds clicked' });
        props.setErrorPageAsync({ error: 'MORE_SPEED_ERROR', isDisplayLoader: true });
    }


    function handleOnContinue() {
        if (!selectedSpeed) {
            setInternetSpeedError('אנא בחר מהירות');
            return;
        }
        props.reportDWH({ actionType: 'Speed List Page', status: 'Ongoing', messageText: 'Speed List Page Page Clicked' });
        gtag4({ event: `Addon_${props.flowType}_Step1_SelectProductContinueButton`, step: '1', action: 'SelectProductContinueButton', funnel_name: `Addon_${props.flowType}` });
        props.setSelectedSpeed(selectedSpeed.name);
        props.createSaleAsync();
    }

};

const mapStateToProps = (state) => {
    return {
        flowType: state.addonsBlock.flowType,
        isDisplayTermsCheckbox: state.addonsBlock.isDisplayTermsCheckbox,
        termsLink: state.addonsBlock.termsLink,
        upgradeSpeedList: state.addonsBlock.upgradeSpeedList,
        customerSpeed: state.addonsBlock.saleCatalog.internetSpeedList.find(x => x.action == 'Existing'),
        primaryEmail: state.addonsBlock.subscriber.primaryEmail,
        isDisplayMoreSpeedLink: state.addonsBlock.isDisplayMoreSpeedLink,
        internetSpeedRemarkList: state.addonsBlock.internetSpeedRemarkList,
    };
};

const mapDispatchToProps = {
    reportDWH,
    setSelectedSpeed,
    createSaleAsync,
    setErrorPageAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(InternetSpeedPage);